import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Configure Telemetry Pipeline using Helm";
const frontMatter = {
  "title": "Configure Telemetry Pipeline using Helm",
  "description": "Use Helm to configure Chronosphere Telemetry Pipeline."
};
import {Tabs} from '@/components';
export function useTOC(props) {
  return [{
    value: "Specify configurations",
    id: "specify-configurations",
    depth: 2
  }, {
    value: "Container image configuration",
    id: "container-image-configuration",
    depth: 2
  }, {
    value: "Global settings",
    id: "global-settings",
    depth: 3
  }, {
    value: "Individual settings",
    id: "individual-settings",
    depth: 3
  }, {
    value: "Services and ports",
    id: "services-and-ports",
    depth: 2
  }, {
    value: "Parameter details",
    id: "parameter-details",
    depth: 2
  }, {
    value: "Troubleshooting",
    id: "troubleshooting",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  if (!Tabs) _missingMdxReference("Tabs", false);
  if (!Tabs.Tab) _missingMdxReference("Tabs.Tab", true);
  return <>{}{"\n"}<_components.h1>{"Configure Telemetry Pipeline using Helm"}</_components.h1>{"\n"}<_components.p>{"If you used Helm to "}<_components.a href="/pipeline-install/install-operator/kubernetes-cluster">{"install Core Operators"}</_components.a>{"\nand "}<_components.a href="/pipeline-install/create-instance">{"create Core Instances"}</_components.a>{",\nyou can also use Helm to configure your Chronosphere Telemetry Pipeline installation\nand to perform various pipeline operations."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"You can use the "}<_components.code>{"helm upgrade -i"}</_components.code>{" shell command to specify your configuration by\npassing a YAML file or specific flags to the command."}</_components.p>{"\n"}<Tabs><Tabs.Tab label="YAML file"><_components.p>{"You can provide a YAML file that specifies the values for the\nparameters while installing the chart. For example:"}</_components.p><_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"helm"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" upgrade"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -i"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" core-instance"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia/core-instance"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" --values"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" values.yaml"}</_components.span></_components.span></_components.code></_components.pre><_components.p>{"The following file is an example "}<_components.code>{"values.yaml"}</_components.code>{":"}</_components.p><_components.pre tabIndex="0" data-language="yaml" data-word-wrap="" data-filename="values.yaml" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"# Turn this chart off/on"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"enabled"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" true"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"name"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"core-instance\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"clusterLogging"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" false"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"# If not set then we use the release name"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"coreInstance"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"coreSecret"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"core-instance\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"cloudToken"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"nKd4jYakEwS7Xwxv9RJ6Nb2NXPjTdg2WZAEA6nwuVtxo2h6VQC2vKmwYCKkrH7sYr9YosSJOQ3at1H5M3rgfDsrUGvepZBX4SRI0CG67aR3KzzqvFekPRRffxwDmdvjfSw9H8lbx6ybXdZD5LTgEDK19W9LeKepEUl1USMcJuPeGPc8Yd3valTUkzkCvG3b90BfJ4wsV\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"cloudTokenSec"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  name"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  key"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"cloudUrl"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"https://cloud-api.calyptia.com\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"enableHealthCheckPipeline"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" false"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"skipServiceCreation"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" false"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"healthCheckPipelinePort"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 2020"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"healthCheckPipelineServiceType"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" LoadBalancer"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"# calyptiaAnnotations is a core-instance specific parameter"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"# NOT to be confused with standard annotations"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"calyptiaAnnotations"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"calyptiaTolerations"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"images"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  fromCloud"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    registry"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" ghcr.io"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    repository"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" calyptia/core-operator/sync-from-cloud"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    tag"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 3.3.5"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    pullSecrets"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" []"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  toCloud"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    registry"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" ghcr.io"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    repository"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" calyptia/core-operator/sync-to-cloud"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    tag"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 3.3.5"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    pullSecrets"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" []"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  hotReload"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    registry"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" ghcr.io"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    repository"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" calyptia/configmap-reload"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    tag"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 0.11.1"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    pullSecrets"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" []"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  ingestCheck"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    registry"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" ghcr.io"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    repository"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" calyptia/core/ingest-check"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    tag"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 0.0.7"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"    pullSecrets"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" []"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"notls"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"true\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"interval"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"15s\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"# enables core instance metrics"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"metrics"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"false\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"metricsPort"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"15334\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"commonAnnotations"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" {}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"commonLabels"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" {}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"podAnnotations"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" {}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"podLabels"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" {}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"nameOverride"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"fullnameOverride"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"namespaceOverride"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"fromCloud"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  resources"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" {}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"toCloud"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  resources"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" {}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"serviceAccount"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  create"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" true"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  name"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  annotations"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{" {}"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"httpProxy"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"httpsProxy"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"noProxy"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"cloudProxy"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"#"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## RBAC configuration"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## @param rbac.create Specifies whether RBAC resources should be created"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"##"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"rbac"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  create"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" true"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"#"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## Global Docker image parameters"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## Please, note that this will override the image parameters, including dependencies, configured to use the global value"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## Current available global Docker image parameters: imageRegistry and imagePullSecrets"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## @section Global parameters"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## @param global.imageRegistry Global Docker image registry"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## @param global.imagePullSecrets Global Docker registry secret names as an array"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"## @param global.storageClass Global StorageClass for Persistent Volume(s)"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"##"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"global"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"  # Note that this overrides any specific ones below"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  imageRegistry"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#6E738D",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#C2C3C5",
    "--shiki-light-font-style": "inherit"
  }}>{"  # Add any custom pull secrets required"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  imagePullSecrets"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#939AB7",
    "--shiki-light": "#24292EFF"
  }}>{"    -"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" regcreds"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  storageClass"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"  pullPolicy"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" IfNotPresent"}</_components.span></_components.span></_components.code></_components.pre></Tabs.Tab><Tabs.Tab label="Shell command"><_components.p>{"Specify each parameter using "}<_components.code>{"helm upgrade -i"}</_components.code>{", and supply arguments using\n"}<_components.code>{"--set key=value[,key=value]"}</_components.code>{". For example:"}</_components.p><_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"helm"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" upgrade"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -i"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" core-instance"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia/core-instance"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" --set"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" name="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"\"core-instance\""}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" --set"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" cloudToken="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"\"CLOUD_TOKEN\""}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" --set"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" coreInstance="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"\"CORE_INSTANCE\""}</_components.span></_components.span></_components.code></_components.pre><_components.p>{"Replace "}<_components.em><_components.code>{"CLOUD_TOKEN"}</_components.code></_components.em>{" and "}<_components.em><_components.code>{"CORE_INSTANCE"}</_components.code></_components.em>{" in accordance with the parameter details."}</_components.p></Tabs.Tab></Tabs>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p>{"Telemetry Pipeline uses "}<_components.a href="https://github.com/bitnami/charts/tree/main/bitnami/common/">{"Bitnami"}</_components.a>{"\nconventions to configure container images."}</_components.p>{"\n"}<_components.h3 id={toc[2].id}>{toc[2].value}</_components.h3>{"\n"}<_components.p>{"To set global settings for your container images, use the "}<_components.code>{"global.imageRegistry"}</_components.code>{" parameter:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"global:"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"  imageRegistry:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"  imagePullSecrets:"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{" []"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"  storageClass:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"\""}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"  pullPolicy:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" IfNotPresent"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"If the global container registry requires authentication, you can provide pull\nsecrets in the "}<_components.code>{"global.imagePullSecrets"}</_components.code>{" parameter."}</_components.p>{"\n"}<_components.h3 id={toc[3].id}>{toc[3].value}</_components.h3>{"\n"}<_components.p>{"To set individual settings for your container images, find that image’s key\nnested under the "}<_components.code>{"images"}</_components.code>{" key. For example, you can modify the "}<_components.code>{"fromCloud"}</_components.code>{"\nimage using the parameters in "}<_components.code>{"images.fromCloud"}</_components.code>{":"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"images:"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"  fromCloud:"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"    registry:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" ghcr.io"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"    repository:"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia/core-operator/sync-from-cloud"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"    tag:"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 3.23.0"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"    pullSecrets:"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{" []"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"If a container image requires authentication, you can provide pull secrets in\nthat image’s "}<_components.code>{"pullSecrets"}</_components.code>{" parameter. that image’s "}<_components.code>{"pullSecrets"}</_components.code>{" parameter. For example,\nto include pull secrets in the "}<_components.code>{"fromCloud"}</_components.code>{" container, store their values in\n"}<_components.code>{"images.fromCloud.pullSecrets"}</_components.code>{"."}</_components.p>{"\n"}<_components.h2 id={toc[4].id}>{toc[4].value}</_components.h2>{"\n"}<_components.p>{"The Helm chart for Telemetry Pipeline provides the following Kubernetes Services:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li><_components.code>{"cloud-api"}</_components.code>{": Corresponds to the Telemetry Pipeline backend ("}<_components.code>{"cloud-api.calyptia.com"}</_components.code>{").\nDefault port: "}<_components.code>{"5000"}</_components.code>{"."}</_components.li>{"\n"}<_components.li><_components.code>{"core"}</_components.code>{": Corresponds to the Telemetry Pipeline web interface ("}<_components.code>{"core.calyptia.com"}</_components.code>{").\nDefault port: "}<_components.code>{"3000"}</_components.code>{"."}</_components.li>{"\n"}</_components.ul>{"\n"}<_components.p>{"Both of these Kubernetes Services use the "}<_components.code>{"LoadBalancer"}</_components.code>{"\n"}<_components.a href="/pipeline-configure/networking#service-types">{"Service type"}</_components.a>{" by default."}</_components.p>{"\n"}<_components.h2 id={toc[5].id}>{toc[5].value}</_components.h2>{"\n"}<_components.p>{"The following table lists the configurable parameters of the "}<_components.code>{"core-instance"}</_components.code>{" Helm\nchart and their default values. Values with a default of "}<_components.code>{"\"\""}</_components.code>{" indicate an empty string."}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Parameter"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Default"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"coreInstance"}</_components.code></_components.td><_components.td>{"Required. If not set, use the release name."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"cloudToken"}</_components.code></_components.td><_components.td>{"Required. Cloud API Token."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"clusterLogging"}</_components.code></_components.td><_components.td>{"Enable cluster logging pipeline creation."}</_components.td><_components.td><_components.code>{"false"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"coreSecret"}</_components.code></_components.td><_components.td>{"Name of the secret containing private key used to decrypt secrets."}</_components.td><_components.td><_components.code>{"\"core-instance\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"cloudUrl"}</_components.code></_components.td><_components.td>{"The URL of the Telemetry Pipeline backend."}</_components.td><_components.td><_components.code>{"\"https://cloud-api.calyptia.com\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"enableHealthCheckPipeline"}</_components.code></_components.td><_components.td>{"Enable "}<_components.a href="/pipelines/concepts#health-check-pipeline">{"health check pipeline"}</_components.a>{" creation alongside the core instance."}</_components.td><_components.td><_components.code>{"false"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"healthCheckPipelinePort"}</_components.code></_components.td><_components.td>{"The port health check uses."}</_components.td><_components.td><_components.code>{"2020"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"healthCheckPipelineServiceType"}</_components.code></_components.td><_components.td>{"The service the health check performs."}</_components.td><_components.td><_components.code>{"LoadBalancer"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"calyptiaAnnotations"}</_components.code></_components.td><_components.td>{"A core-instance specific parameter not to be confused with standard annotations. Pass multiple annotations in the form "}<_components.code>{"first=primary\\,second=another"}</_components.code>{". Commas must be escaped due to Helm reservation."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.fromCloud.registry"}</_components.code></_components.td><_components.td>{"The registry Telemetry Pipeline software downloads from."}</_components.td><_components.td><_components.code>{"ghcr.io"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.fromCloud.repository"}</_components.code></_components.td><_components.td>{"The software repository location."}</_components.td><_components.td><_components.code>{"calyptia/core-operator/sync-from-cloud"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.fromCloud.tag"}</_components.code></_components.td><_components.td>{"The release tag to download."}</_components.td><_components.td>{"This value is the most recent tag. Example: "}<_components.code>{"3.3.5"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.toCloud.registry"}</_components.code></_components.td><_components.td>{"The registry Telemetry Pipeline software synchronizes from."}</_components.td><_components.td><_components.code>{"ghcr.io"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.toCloud.repository"}</_components.code></_components.td><_components.td>{"The software repository location."}</_components.td><_components.td><_components.code>{"calyptia/core-operator/sync-to-cloud"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.toCloud.tag"}</_components.code></_components.td><_components.td>{"The release tag to download."}</_components.td><_components.td>{"This value is the most recent tag. Example: "}<_components.code>{"3.3.5"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.hotReload.registry"}</_components.code></_components.td><_components.td>{"The registry to hot reload from."}</_components.td><_components.td><_components.code>{"ghcr.io"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.hotReload.repository"}</_components.code></_components.td><_components.td>{"The software repository location."}</_components.td><_components.td><_components.code>{"calyptia/configmap-reload"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.hotReload.tag"}</_components.code></_components.td><_components.td>{"The release tag to download."}</_components.td><_components.td>{"This value is the most recent tag. Example: "}<_components.code>{"0.11.1"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.ingestCheck.registry"}</_components.code></_components.td><_components.td>{"The registry containing information for ingest checks."}</_components.td><_components.td><_components.code>{"ghcr.io"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.ingestCheck.repository"}</_components.code></_components.td><_components.td>{"The ingest check repository."}</_components.td><_components.td><_components.code>{"calyptia/core/ingest-check"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"images.ingestCheck.tag"}</_components.code></_components.td><_components.td>{"The release tag."}</_components.td><_components.td><_components.code>{"0.0.7"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"notls"}</_components.code></_components.td><_components.td>{"Determine whether or not connections use TLS."}</_components.td><_components.td><_components.code>{"\"true\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"interval"}</_components.code></_components.td><_components.td>{"Time period between ingest checks."}</_components.td><_components.td><_components.code>{"\"15s\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"metricsPort"}</_components.code></_components.td><_components.td>{"The communication port."}</_components.td><_components.td><_components.code>{"\"15334\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"nameOverride"}</_components.code></_components.td><_components.td>{"Override the generated chart name."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"fullnameOverride"}</_components.code></_components.td><_components.td>{"Override the full generated name."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"serviceAccount.create"}</_components.code></_components.td><_components.td>{"Whether to create a service account."}</_components.td><_components.td><_components.code>{"true"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"serviceAccount.name"}</_components.code></_components.td><_components.td>{"The service account name."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"rbac.create"}</_components.code></_components.td><_components.td>{"Create role based access controls."}</_components.td><_components.td><_components.code>{"true"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"global.imageRegistry"}</_components.code></_components.td><_components.td>{"Overrides any of the specific registries."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"global.storageClass"}</_components.code></_components.td><_components.td>{"The name of the global storage class."}</_components.td><_components.td><_components.code>{"\"\""}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.code>{"global.pullPolicy"}</_components.code></_components.td><_components.td>{"Determines the pull policy used by Kubernetes."}</_components.td><_components.td><_components.code>{"IfNotPresent"}</_components.code></_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h2 id={toc[6].id}>{toc[6].value}</_components.h2>{"\n"}<_components.p>{"If you need assistance, contact "}<_components.a href="/support">{"Chronosphere Support"}</_components.a>{".\nAs part of the support process, Chronosphere recommends downloading and running the\n"}<_components.a href="https://raw.githubusercontent.com/calyptia/charts/master/support.sh"><_components.code>{"support.sh"}</_components.code></_components.a>{"\nscript, which gathers information about your Telemetry Pipeline installation\nand packages this information into an archive that you can attach to your ticket."}</_components.p></>;
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/pipeline-configure/helm',
  {"filePath":"pages/pipeline-configure/helm.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)